<script setup lang="ts">
import { useNuxtApp } from '#app'
import LoadImg from '@monorepo/ui/components/LoadImg.vue'
import { useShoppingLists } from '@/composables/shoppingLists'
import { computed } from 'vue'

const { carts, selectedCart } = useShoppingLists()

const currentCart = computed(() => {
  return carts.value.find(cart => cart.name === selectedCart.value) || carts.value[0]
})

const { $vm: vm } = useNuxtApp()

const emit = defineEmits<{
  (e: 'open-shopping-panel'): void
}>()

function openSaveListMenu() {
  emit('open-shopping-panel')
}

function onCartChange(e: Event) {
  const name = (e.target as HTMLSelectElement).value
  selectedCart.value = name;
  emit('open-shopping-panel')    
}

</script>

<template>
  <div 
    id="CartPanel"
    class="hidden md:flex absolute bottom-2 right-0
           rounded-lg bg-[hsl(var(--neutral))] shadow-lg
           w-72 p-2"
           style="height:96px;"
  >
    <div class="grid grid-cols-2 gap-x-2 gap-y-2">
      <select
  v-model="selectedCart"
  class="inline-block text-sm px-1 py-1 rounded border border-primary"
  @change="emit('open-shopping-panel')"    
>
  <option
    v-for="cart in carts"
    :key="cart.name"
    :value="cart.name"
  >{{ cart.name }}</option>
</select>

      <div class="flex justify-end items-center">
        <span class="text-sm">
          <span class="text-[#64F4D5]">{{ currentCart.items.length }}</span>
          Items
        </span>
      </div>

      <!-- 3: list icon -->
      <div class="flex justify-start items-start">
        <LoadImg style="height:48px;width:118px;"
          imgname="img-cartlist"
          tagname="img-cartlist"
          @click="emit('open-shopping-panel')" 
        />
      </div>

      <!-- 4: download icon -->
      <div class="flex justify-end items-start">
        <LoadImg style="height:48px;width:118px;"
          imgname="img-cart"
          tagname="img-cart"
          @click="emit('open-shopping-panel')"
        />
      </div>
    </div>
  </div>
</template>
